import { Colors, Metrics } from '@origin-digital/style-guide';
import * as React from 'react';
import styled from 'styled-components';

interface SeparatorProps {
  color: Colors;
}

const Separator: React.FC<SeparatorProps> = ({ color }) => <GreyRuler color={color} />;

const GreyRuler = styled.hr`
  border: none;
  border-bottom: 1px solid ${(props) => props.color};
  margin-top: ${Metrics.Spacing.M_Y_LG}px;
  margin-bottom: ${Metrics.Spacing.M_Y_LG}px;
`;

export { Separator };
